import { Row } from "react-bootstrap";
import React from "react";

interface FooterPanelProps {
    title: string;
    botoes?: React.ReactNode[];
    contador?: number;
}

const FooterPanel: React.FC<FooterPanelProps> = (props) => {
    const botoesHeaderPanel = () => {
        return (
            <div className="footer-button">
                {props.botoes?.map((botao) => {
                    return botao;
                })}
            </div>
        );
    };

    return (
        <div className="pb-3">
            <Row className="bottom-div">
                {botoesHeaderPanel()}
            </Row>
        </div>
    );
};

export default FooterPanel;
